import { useEffect, useState } from "react";
// material-ui
import { Box, Typography } from "@mui/material";

// project import
import NavGroup from "./NavGroup";
import menuItem from "menu-items";
import api from "services/api";
import TokenService from "services/authentication/TokenService";

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
    const [allowedModules, setAllowedModules] = useState(null);

    useEffect(() => {
        const token = TokenService.getAccessToken();
        if (!token) return;

        api.get("api/analytics/auth/me")
            .then(({ data }) => {
                const modules = data?.data?.appModules;
                if (Array.isArray(modules)) {
                    setAllowedModules(modules.map((m) => m.type));
                }
            })
            .catch(() => {
                // on error show all menus
            });
    }, []);

    const visibleItems =
        allowedModules === null
            ? menuItem.items
            : menuItem.items.filter(
                  (item) => !item.appModule || allowedModules.includes(item.appModule)
              );

    const navGroups = visibleItems.map((item) => {
        switch (item.type) {
            case "group":
                return <NavGroup key={item.id} item={item} />;
            default:
                return (
                    <Typography
                        key={item.id}
                        variant="h6"
                        color="error"
                        align="center"
                    >
                        Fix - Navigation Group
                    </Typography>
                );
        }
    });

    return <Box sx={{ pt: 2, background: "rgb(22,32,90)" }}>{navGroups}</Box>;
};

export default Navigation;
